// client/src/components/pages/LexiStar/TripDetail/tripMath.js
//
// Read-side arithmetic for the trip detail's "how was this calculated?"
// expanders (LS-09 §1.1 "trust through shown workings"). The engine owns every
// number (LS-04 §9, §10); these helpers only restate the formula with the
// trip's own inputs so the controller can check the figure on screen.

/** LS-04 §10: breach = |variance| > max(tolerance_pct × net_dispatch, tolerance_kg). */
export const VARIANCE_TOL_PCT = 0.005;
export const VARIANCE_TOL_KG = 250;

export function varianceTolerance(dispatchNetKg) {
  const d = Number(dispatchNetKg);
  if (!Number.isFinite(d)) return VARIANCE_TOL_KG;
  return Math.max(VARIANCE_TOL_PCT * d, VARIANCE_TOL_KG);
}

/** Server variance columns win; computed from the nets when absent. */
export function weighVariance(trip) {
  const dispatch = trip?.dispatch_net_kg;
  const receipt = trip?.receipt_net_kg;
  if (dispatch == null || receipt == null) return null;
  const kg = trip.variance_kg ?? Number(dispatch) - Number(receipt);
  const pct = trip.variance_pct ?? (Number(dispatch) ? kg / Number(dispatch) : null);
  const tolerance = varianceTolerance(dispatch);
  const breach =
    typeof trip.variance_breach === 'boolean' ? trip.variance_breach : Math.abs(kg) > tolerance;
  return { kg, pct, tolerance, breach };
}

/** Approved extra km = adjusted − planned (FR-DEV-006: originals retained). */
export const approvedExtraKm = (trip) => {
  const p = Number(trip?.planned_km);
  const a = Number(trip?.adjusted_km);
  return Number.isFinite(p) && Number.isFinite(a) ? a - p : null;
};

/** Duration in seconds between two ISO instants, or null. */
export const spanSeconds = (from, to) => {
  if (!from || !to) return null;
  const s = (new Date(to).getTime() - new Date(from).getTime()) / 1000;
  return Number.isFinite(s) && s >= 0 ? s : null;
};

/** "DISPATCHED" / "TRIP.ARRIVED_SOURCE" → "Dispatched" / "Arrived source". */
export function timelineLabel(kind) {
  if (!kind) return '';
  const k = String(kind)
    .replace(/^[A-Z]+\./, '')
    .replace(/_/g, ' ')
    .toLowerCase();
  return k.charAt(0).toUpperCase() + k.slice(1);
}
